let storageScopeToken = "";

function normalizeStorageScopeToken(value: string | null | undefined): string {
  const normalized = (value ?? "").trim();
  if (!normalized) return "";
  return encodeURIComponent(normalized);
}

export function setStringDevStorageScopeToken(value: string | null | undefined): void {
  storageScopeToken = normalizeStorageScopeToken(value);
}

export function scopeStringDevStorageKey(baseKey: string): string {
  if (!storageScopeToken) {
    return baseKey;
  }
  return `${baseKey}::${storageScopeToken}`;
}
